import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'

import { HelpPost } from '@professocialApi/professocial-core-frontend-api'

import { ApiError } from '../coreRoot.reducer'
import {
  getHelpPost,
  getHelpPostList,
  createEditorHelpPost,
  deleteEditorHelpPost,
  getEditorHelpPost, updateEditorHelpPost, setHelpPost,
} from './help.actions'

export interface HelpState {
  fetching: boolean
  helpPosts?: HelpPost[]
  helpPost?: HelpPost
  error: ApiError
}

const INITIAL_STATE: HelpState = {
  fetching: false,
  error: {},
}

export const HelpReducer = reducerWithInitialState(INITIAL_STATE)
  .case(setHelpPost, (state, helpPost) => {
    return ({ ...state, helpPost })
  })

/**
   * getHelpPost
   */
  .case(getHelpPost.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getHelpPost
    })
  })

  .case(getHelpPost.done, (state, { result }) => {
    return produce(state, draft => {
      draft = {
        ...draft,
        helpPost: result,
      }
      draft.fetching = false
      return draft
    })
  })

  .case(getHelpPost.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getHelpPost = (error as Response)
    })
  })

/**
   * getHelpPostList
   */
  .case(getHelpPostList.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getIgPage
    })
  })

  .case(getHelpPostList.done, (state, { result }) => {
    return produce(state, draft => {
      draft = {
        ...draft,
        helpPosts: result,
      }
      draft.fetching = false
      return draft
    })
  })

  .case(getHelpPostList.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getHelpPostList = (error as Response)
    })
  })

/**
   * createEditorHelpPost
   */
  .case(createEditorHelpPost.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getIgPage
    })
  })

  .case(createEditorHelpPost.done, (state, { result }) => {
    return produce(state, draft => {
      draft.helpPost = result
      draft.fetching = false
      return draft
    })
  })

  .case(createEditorHelpPost.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getHelpPostList = (error as Response)
    })
  })

/**
   * deleteEditorHelpPost
   */
  .case(deleteEditorHelpPost.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getIgPage
    })
  })

  .case(deleteEditorHelpPost.done, (state, { result }) => {
    return produce(state, draft => {
      draft.helpPost = result
      draft.fetching = false
      return draft
    })
  })

  .case(deleteEditorHelpPost.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getHelpPostList = (error as Response)
    })
  })

/**
   * getEditorHelpPost
   */
  .case(getEditorHelpPost.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getHelpPost
    })
  })

  .case(getEditorHelpPost.done, (state, { result }) => {
    return produce(state, draft => {
      draft.helpPost = result
      draft.fetching = false
      return draft
    })
  })

  .case(getEditorHelpPost.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getHelpPost = (error as Response)
    })
  })

/**
   * updateEditorHelpPost
   */
  .case(updateEditorHelpPost.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getHelpPost
    })
  })

  .case(updateEditorHelpPost.done, (state, { result }) => {
    return produce(state, draft => {
      draft.helpPost = result
      draft.fetching = false
      return draft
    })
  })

  .case(updateEditorHelpPost.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getHelpPost = (error as Response)
    })
  })
